const CRM_ROLE_NAME_I18N_KEYS: Record<string, string> = {
  国内区域VP: 'roleNameDomesticRegionalVp',
  国内售前: 'roleNameDomesticPresales',
  国内销售: 'roleNameDomesticSales',
  国内销售总监: 'roleNameDomesticSalesDirector',
  国内销售总管: 'roleNameDomesticSalesHead',
  国内销售监察: 'roleNameDomesticSalesSupervisor',
  '海外-KA-POC审批': 'roleNameOverseasKaPocApprover',
  海外区域VP: 'roleNameOverseasRegionalVp',
  海外售前: 'roleNameOverseasPresales',
  海外商机负责人: 'roleNameOverseasOpportunityOwner',
  海外客户负责人: 'roleNameOverseasAccountOwner',
  海外销售: 'roleNameOverseasSales',
  海外销售总监: 'roleNameOverseasSalesDirector',
  财务: 'roleNameFinance',
};

export function crmRoleNameI18nKey(roleName: string) {
  return CRM_ROLE_NAME_I18N_KEYS[roleName] ?? null;
}
